/**
 * Events Accordion Module
 * Handles accordion functionality for events listings
 * Extends BaseAccordion for consistent behavior
 */

import { onDOMReady, devLog } from './utils.js';
import { BaseAccordion } from './base-accordion.js';

class EventsAccordion extends BaseAccordion {
    constructor() {
        super({
            selector: '[data-event-toggle]',
            debug: false
        });
    }

    // Override the CSS classes to use event-accordion specific classes
    openAccordion(toggle, content) {
        super.openAccordion(toggle, content);
        
        // Add event-accordion specific classes
        toggle.classList.add('event-accordion__toggle--expanded');
        content.classList.add('event-accordion__expanded-content--expanded');
    }

    closeAccordion(toggle, content) {
        super.closeAccordion(toggle, content);
        
        // Remove event-accordion specific classes
        toggle.classList.remove('event-accordion__toggle--expanded');
        content.classList.remove('event-accordion__expanded-content--expanded');
    }
}

// Initialize when DOM is loaded
onDOMReady(() => {
    new EventsAccordion();
});

// Re-initialize for dynamic content (like in block editor)
if (typeof acf !== 'undefined') {
    acf.addAction('render_block_preview/type=events-listing', () => {
        new EventsAccordion();
    });
} 